$(document).ready(() => {
    const options = {
        selectorClass: {
            warningBar: '.ongoing-events',
            servicesToggle: '.services-toggle',
            menuSection: '.menu-section',
            servicesSection: '.services-section',
            searchToggle: '.search-toggle',
            searchToggleMobile: '.search-toggle-mobile',
            searchField: '.main-header .search-field',
            header: '#header',
            body: 'body',
            menuTitleWrapper: '.menu-title-wrapper',
            aboutToggle: '.about-toggle',
            sustainToggle: '.sustain-toggle',
            newsToggle: '.news-toggle',
            clickOutside: '.overlay'
        },
        toggleClass: {
            open: 'open',
            servicesOpen: 'services-open',
            searchOpen: 'search-open',
            noScroll: 'no-scroll',
            aboutOpen: 'about-open',
            sustainOpen: 'sustain-open',
            newsOpen: 'news-open'
        }
    };

    const toggleMenu = function() {
        window.scrollTo(0, 0);
        if ($(options.selectorClass.header).hasClass(options.toggleClass.searchOpen)) {
            $(options.selectorClass.header).toggleClass(options.toggleClass.searchOpen);
        } else if ($(options.selectorClass.header).hasClass(options.toggleClass.aboutOpen)) {
            $(options.selectorClass.header).toggleClass(options.toggleClass.aboutOpen);
        }
        $(options.selectorClass.header).toggleClass(options.toggleClass.servicesOpen);
        if ($(options.selectorClass.header).hasClass(options.toggleClass.servicesOpen)) {
            $(options.selectorClass.body).addClass(options.toggleClass.noScroll);
        } else {
            $(options.selectorClass.body).removeClass(options.toggleClass.noScroll);
        }
    };

    const toggleAboutMenu = function() {
        $(options.selectorClass.header).removeClass(options.toggleClass.searchOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.sustainOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.newsOpen);
        $(options.selectorClass.body).toggleClass(options.toggleClass.noScroll);
        $(options.selectorClass.header).toggleClass(options.toggleClass.aboutOpen);

        if ($(options.selectorClass.header).hasClass(options.toggleClass.aboutOpen)) {
            $(options.selectorClass.body).addClass(options.toggleClass.noScroll);
        } else {
            $(options.selectorClass.body).removeClass(options.toggleClass.noScroll);
        }
    };

    const toggleNewsMenu = function() {
        $(options.selectorClass.header).removeClass(options.toggleClass.aboutOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.sustainOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.searchOpen);
        $(options.selectorClass.body).toggleClass(options.toggleClass.noScroll);

        $(options.selectorClass.header).toggleClass(options.toggleClass.newsOpen);

        if ($(options.selectorClass.header).hasClass(options.toggleClass.newsOpen)) {
            $(options.selectorClass.body).addClass(options.toggleClass.noScroll);
        } else {
            $(options.selectorClass.body).removeClass(options.toggleClass.noScroll);
        }
    };

    const toggleSustainMenu = function() {
        $(options.selectorClass.header).removeClass(options.toggleClass.aboutOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.newsOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.searchOpen);
        $(options.selectorClass.body).toggleClass(options.toggleClass.noScroll);

        $(options.selectorClass.header).toggleClass(options.toggleClass.sustainOpen);

        if ($(options.selectorClass.header).hasClass(options.toggleClass.sustainOpen)) {
            $(options.selectorClass.body).addClass(options.toggleClass.noScroll);
        } else {
            $(options.selectorClass.body).removeClass(options.toggleClass.noScroll);
        }
    };

    const toggleSearch = function() {
        $(options.selectorClass.header).removeClass(options.toggleClass.aboutOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.sustainOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.newsOpen);
        $(options.selectorClass.body).removeClass(options.toggleClass.noScroll);

        $(options.selectorClass.header).toggleClass(options.toggleClass.searchOpen);
        $(options.selectorClass.searchField).focus();

        if ($(options.selectorClass.header).hasClass(options.toggleClass.searchOpen)) {
            $(options.selectorClass.body).addClass(options.toggleClass.noScroll);
        } else {
            $(options.selectorClass.body).removeClass(options.toggleClass.noScroll);
        }
    };

    $(options.selectorClass.clickOutside).on('click', () => {
        $(options.selectorClass.body).removeClass(options.toggleClass.noScroll);

        $(options.selectorClass.header).removeClass(options.toggleClass.searchOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.aboutOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.sustainOpen);
        $(options.selectorClass.header).removeClass(options.toggleClass.newsOpen);
    });

    const toggleMenuLinks = function(ev) {
        $(ev).toggleClass(options.toggleClass.open);
    };
    $(options.selectorClass.servicesToggle).on('click', () => {
        toggleMenu();
    }).on('keypress', function(e) {
        if (e.which === 13) {
            toggleMenu();
        }
    });

    $(options.selectorClass.aboutToggle).on('click', (ev) => {
        toggleAboutMenu(ev);
    }).on('keypress', function(e) {
        if (e.which === 13) {
            toggleAboutMenu();
        }
    });

    $(options.selectorClass.sustainToggle).on('click', (ev) => {
        toggleSustainMenu(ev);
    }).on('keypress', function(e) {
        if (e.which === 13) {
            toggleSustainMenu();
        }
    });

    $(options.selectorClass.newsToggle).on('click', (ev) => {
        toggleNewsMenu(ev);
    }).on('keypress', function(e) {
        if (e.which === 13) {
            toggleNewsMenu();
        }
    });

    $(options.selectorClass.menuTitleWrapper).on('click', (ev) => {
        toggleMenuLinks($(ev.currentTarget).parent(options.selectorClass.menuSection));
    }).on('keypress', function(ev) {
        if (e.which === 13) {
            toggleMenuLinks($(ev.currentTarget).parent(options.selectorClass.menuSection));
        }
    });

    $(options.selectorClass.searchToggle).on('click', () => {
        toggleSearch();
    }).on('keypress', function(e) {
        if (e.which === 13) {
            toggleSearch();
        }
    });

    $(options.selectorClass.searchToggleMobile).on('click', () => {
        toggleSearch();
    }).on('keypress', function(e) {
        if (e.which === 13) {
            toggleSearch();
        }
    });


    $(window).scroll(function() {
        if ($(document).scrollTop() > 200) {
            $(options.selectorClass.warningBar).slideUp(200);
        }

        if ($(document).scrollTop() < 150) {
            $(options.selectorClass.warningBar).slideDown(200);
        }
    });
});
